export { default } from "./ForgeSelect";
export { default as ForgeSelect } from "./ForgeSelect";
export type {
  AjaxConfig,
  DataItem,
  ForgeSelectEvent,
  ForgeSelectOptions,
  ForgeSelectPlugin,
  ForgeSelectValue,
  Option,
  OptionGroup,
  TemplateFn,
} from "./types";
